import React from 'react'
import { useMatch } from 'react-router'
import { routes as signupRoutes } from '@mobi/account/Areas/SignUp/Utils/routes'
import { VerificationAccountHomePage } from '@mobi/account/Areas/VerificationAccount'
import { useBetAccount } from '@mobi/account/Hooks'
import { useDisableAppHeaderRender } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderRender'
import { useLogon } from '@core/Utils/hooks'

export const VerificationAccountGate = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn, accountNumber } = useLogon()
  const enabled = isLoggedIn === true && accountNumber !== null
  const {
    data: betAccount,
    isLoading: isBetAccountLoading,
    isError: isBetAccountError,
  } = useBetAccount({ enabled })
  const isVerificationAccount = betAccount?.IdVerificationOnlyInd?.toUpperCase() === 'Y'
  const isSignupPage = useMatch(signupRoutes.any)

  if (
    !isSignupPage &&
    isLoggedIn &&
    !isBetAccountLoading &&
    (isVerificationAccount || isBetAccountError)
  ) {
    return (
      <VerificationAccountHomePage
        betAccountNumber={betAccount?.BetAccountNumber}
        useDisableAppHeaderRender={useDisableAppHeaderRender}
        isBetAccountError={isBetAccountError}
      />
    )
  }

  return children
}
